import { client } from '@atlassian/rovo-content-bridge-api/client-types';
import { isWebviewContext } from '@atlassian/rovo-content-bridge-api/desktop-apis';
import { getBrowserBridgeAPI } from '@atlassian/rovo-content-bridge-api/singleton';
import { ROVO_CHAT_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/clients/rovo-chat-client';
import {
	StartBackgroundAgentConversationCommand,
	type StartBackgroundAgentConversationCommandProperties,
} from '@atlassian/rovo-content-bridge-api-commands/commands/start-background-agent-conversation-command';

/** Returns whether the local receiver accepted ownership, not whether the agent has finished. */
export async function sendBackgroundAgentInvocation({
	agentId,
	agentIdentityAccountId,
	agentName,
	agentNamedId,
	isThirdPartyAgent,
	productKey,
	source,
	prompt,
	name,
	sourceId,
	tags,
	commentMentionContext,
}: {
	agentId: string;
	agentIdentityAccountId: string;
	agentName: string;
	agentNamedId: string;
	isThirdPartyAgent: boolean;
	productKey: string;
	source: string;
	prompt: string;
	name: string;
	sourceId: string;
	tags: string[];
	commentMentionContext?: StartBackgroundAgentConversationCommandProperties['commentMentionContext'];
}): Promise<boolean> {
	// Desktop owns its own command receiver and does not yet support this extension.
	if (isWebviewContext()) {
		return false;
	}
	const bridge = getBrowserBridgeAPI();
	const senderId = client(`confluence-comment-agent-${crypto.randomUUID()}`);
	bridge.ready(senderId);
	try {
		const result = await bridge
			.send(StartBackgroundAgentConversationCommand, {
				senderId,
				receiverId: ROVO_CHAT_CLIENT_ID,
				agentId,
				agentIdentityAccountId,
				agentName,
				agentNamedId,
				isThirdPartyAgent,
				productKey,
				source,
				prompt,
				name,
				sourceId,
				tags,
				...(commentMentionContext ? { commentMentionContext } : {}),
				useCurrentPageContext: true,
			})
			.result();
		return result === true;
	} finally {
		// The receiver acknowledges before running the agent; this client owns no stream UI.
		bridge.teardown(senderId);
	}
}
